export default __webpack_public_path__ + "static/media/CostManagement.32f172d8.md";